import { useGetUser } from "@dealer-center/ddc-api-user-fetch";

export const useIsGvmRwAccessUser = (): boolean => {
  const { data: userData } = useGetUser();
  return !!userData?.userPermissions?.GVM_VIDEO_WRITE;
};
